// Marker/cluster z-ordering for the overlay layers.
//
// Each overlay layer (asset / geozone / infra) draws its markers AND its
// cluster icons in its own Leaflet pane, so a whole layer sits at one z-level
// relative to the others. The layer classes themselves are dumb: they only
// apply whatever pane the composition assigned to them (layer.options.pane).
//
// The *order* of these panes is decided by the page (see ControlLayers): the
// page's always-visible primary layer sits on top, and the toggleable layers
// stack underneath in the order the layer selector lists them. This module only
// owns the pane names + the baseline (asset-on-top) z-index; ControlLayers
// re-stacks them per page.
export const LAYER_MARKER_PANES: Record<string, string> = {
  ASSET: "assetMarkerPane",
  GEOZONE: "geozoneMarkerPane",
  INFRA: "infraMarkerPane",
};

// Top → bottom. Baseline order (matches the layer selector's default order) used
// when no page-specific ordering has been applied yet. Higher = drawn on top.
export const DEFAULT_LAYER_Z_ORDER: string[] = ["ASSET", "GEOZONE", "INFRA"];

// z-index band. NOTE: this app runs a COMPRESSED pane z-index scheme (not
// Leaflet's default 200-700). The live panes are: tile=2, custom=3, overlay=4,
// shadow=5, geozone(polygons)=5, marker=6, tooltip=7, popup=8. The hover popup
// therefore lives at z=8 and tooltips at z=7 — so the marker band MUST stay
// at/below marker level (6) or it climbs over the popup/tooltips.
//
// The TOP layer sits at marker-pane level (6) — where the asset layer lived when
// hover popups worked correctly — and lower layers stack just beneath it. Ties
// with the built-in panes (marker=6, shadow=5, overlay=4) resolve by DOM order:
// our panes are created after them, so our markers draw above that pane's own
// content. Do NOT raise LAYER_PANE_Z_TOP to 7+ (tooltip/popup must stay on top).
export const LAYER_PANE_Z_TOP = 6;
export const LAYER_PANE_Z_STEP = 1;
